import React from 'react';
import PropTypes from 'prop-types';
import { Button, Split, SplitItem, Title, TitleSizes } from '@patternfly/react-core';
import { HistoryIcon, UndoIcon } from '@patternfly/react-icons';

import PlayerTable from './PlayerTable';

function Drafted(props) {
  let players = props.players.slice().filter((p) => p.drafted);
  players = players.sort((a, b) => b.drafted - a.drafted);

  return (
    <div id="drafted-all">
      <div id="drafted-header">
        <Title headingLevel="h1" size={TitleSizes.lg}>
          Draft History
        </Title>
        <Split>
          <SplitItem>
            <Button
              variant="tertiary"
              isSmall={true}
              icon={<UndoIcon />}
              onClick={() => props.undo(props.currentDraft)}
            >
              Undo
            </Button>
          </SplitItem>
          <SplitItem isFilled></SplitItem>
          <SplitItem>
            <Button variant="tertiary" isSmall={true} icon={<HistoryIcon />} onClick={() => props.reset()}>
              Reset
            </Button>
          </SplitItem>
        </Split>
      </div>
      <div className="drafted-table">
        <PlayerTable fields={['drafted', 'name', 'position', 'team']} players={players} disableColor={true} />
      </div>
    </div>
  );
}

Drafted.propTypes = {
  currentDraft: PropTypes.number.isRequired,
  reset: PropTypes.func.isRequired,
  undo: PropTypes.func.isRequired,
  players: PropTypes.array.isRequired,
};

export default Drafted;
